// extracted by mini-css-extract-plugin
module.exports = {"snackbar":"snackbar_snackbar__4WpD5","visible":"snackbar_visible__7bciV"};